const addCommas = (num: number | undefined) => {
    if (num === undefined) return '';
    if (num < 10) return (Math.round(num * 100) / 100).toString();
    if (num < 1000) return Math.round(num).toString();

    return Math.round(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export { addCommas };
